import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, type Stripe } from '@stripe/stripe-js';
import { stripePublishableKey } from '../config/stripe';
import React from 'react';

// Stripe.js is loaded once per page load, not on every render: <Elements> rejects a
// changed `stripe` prop. A failed load is not kept, so the next render tries again.
let stripePromise: Promise<Stripe | null> | null = null;
const getStripe = () => {
    if (!stripePromise) {
        stripePromise = loadStripe(stripePublishableKey).catch((error: unknown) => {
            stripePromise = null;
            throw error;
        });
    }
    return stripePromise;
};

export const StripeProvider = ({ children, clientSecret }: { children: React.ReactNode; clientSecret?: string }) => {
    const options = clientSecret ? {
        clientSecret,
        appearance: {
            theme: 'stripe' as const,
        },
    } : undefined;

    // FNP-1925: <Elements> keeps the clientSecret it was mounted with and ignores a new one.
    // Keying on the secret remounts it instead, so it can never confirm a stale SetupIntent.
    return (
        <Elements key={clientSecret ?? 'no-client-secret'} stripe={getStripe()} options={options}>
            {children}
        </Elements>
    );
};
